module.exports = __webpack_public_path__ + "img/card_icon_6.0c06a1d3.svg";